/* tslint:disable */

declare var Object: any;
export interface EmpresaInterface {
  "idEmpresa"?: number;
  "nombreFantasia": string;
  "razonSocial": string;
  "logoClaro"?: string;
  "logoOscuro"?: string;
  "cuit": string;
  "domicilio"?: string;
  "emailRecepcion"?: string;
  "emailAdministrativo"?: string;
  "telefonoContacto"?: string;
  "nombreContacto"?: string;
  "telefonoInforme"?: string;
  "emailInforme"?: string;
  "activo": boolean;
  "idUsuario": number;
  "fechaCreacion": Date;
  "externo": boolean;
}

export class Empresa implements EmpresaInterface {
  "idEmpresa": number;
  "nombreFantasia": string;
  "razonSocial": string;
  "logoClaro": string;
  "logoOscuro": string;
  "cuit": string;
  "domicilio": string;
  "emailRecepcion": string;
  "emailAdministrativo": string;
  "telefonoContacto": string;
  "nombreContacto": string;
  "telefonoInforme": string;
  "emailInforme": string;
  "activo": boolean;
  "idUsuario": number;
  "fechaCreacion": Date;
  "externo": boolean;
  constructor(data?: EmpresaInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Empresa`.
   */
  public static getModelName() {
    return "Empresa";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Empresa for dynamic purposes.
  **/
  public static factory(data: EmpresaInterface): Empresa{
    return new Empresa(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Empresa',
      plural: 'Empresa',
      path: 'Empresa',
      idName: 'idEmpresa',
      properties: {
        "idEmpresa": {
          name: 'idEmpresa',
          type: 'number'
        },
        "nombreFantasia": {
          name: 'nombreFantasia',
          type: 'string'
        },
        "razonSocial": {
          name: 'razonSocial',
          type: 'string'
        },
        "logoClaro": {
          name: 'logoClaro',
          type: 'string'
        },
        "logoOscuro": {
          name: 'logoOscuro',
          type: 'string'
        },
        "cuit": {
          name: 'cuit',
          type: 'string'
        },
        "domicilio": {
          name: 'domicilio',
          type: 'string'
        },
        "emailRecepcion": {
          name: 'emailRecepcion',
          type: 'string'
        },
        "emailAdministrativo": {
          name: 'emailAdministrativo',
          type: 'string'
        },
        "telefonoContacto": {
          name: 'telefonoContacto',
          type: 'string'
        },
        "nombreContacto": {
          name: 'nombreContacto',
          type: 'string'
        },
        "telefonoInforme": {
          name: 'telefonoInforme',
          type: 'string'
        },
        "emailInforme": {
          name: 'emailInforme',
          type: 'string'
        },
        "activo": {
          name: 'activo',
          type: 'boolean'
        },
        "externo": {
          name: 'externo',
          type: 'boolean'
        },
        "idUsuario": {
          name: 'idUsuario',
          type: 'number'
        },
        "fechaCreacion": {
          name: 'fechaCreacion',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/lbsdk/models/Empresa.ts